import { proforientationApplicationSelectors } from 'portfolio3/features/proforientation/model/selectors';
import { createSelector } from 'reselect';
import { extractDatesFromNestedItems } from 'utils';

export const proforientationApplicationProbesYearsSelector = createSelector(
  [proforientationApplicationSelectors.probes],
  (proforientationApplicationProbes) =>
    extractDatesFromNestedItems(
      [proforientationApplicationProbes],
      [
        {
          type: 'date',
          field: 'unformattedEventDate',
        },
      ],
    ),
);
